import React, { Suspense } from 'react';
import { Router, Switch } from 'react-router-dom';
import history from 'history/history';
import { ROUTES } from 'router/routes';
import { getValidPath } from 'helpers/path';

import Loader from 'componentsShared/Loader/Loader';
import CustomRoute from './CustomRouter';
import ProtectedRoute from './ProtectedRoute';
import CustomRedirect from './CustomRedirect';

const TravelersDetailsPage = React.lazy(() =>
  import('pages/TravelersDetailsPage/TravelersDetailsPage')
);
const SignInPage = React.lazy(() => import('pages/SignInPage/SignInPage'));
const LoginEmployeePage = React.lazy(() =>
  import('pages/LoginEmployeePage/LoginEmployeePage')
);
const SignOutPage = React.lazy(() => import('pages/SignOutPage/SignOutPage'));
const NewTravelerPage = React.lazy(() =>
  import('pages/NewTravelerPage/NewTravelerPage')
);
const CustomerDetailsPage = React.lazy(() =>
  import('pages/CustomerDetailsPage/CustomerDetailsPage')
);
const AdminCustomersPage = React.lazy(() =>
  import('pages/AdminCustomersPage/AdminCustomersPage')
);
const AdminEmployeesPage = React.lazy(() =>
  import('pages/AdminEmployeesPage/AdminEmployeesPage')
);
const AdminTravelerTemplatesPage = React.lazy(() =>
  import('pages/AdminTravelerTemplatesPage/AdminTravelerTemplatesPage')
);
const AdminControlValuesPage = React.lazy(() =>
  import('pages/AdminControlValuesPage/AdminControlValuesPage')
);
const AdminNCRPage = React.lazy(() =>
  import('pages/AdminNCRPage/AdminNCRPage')
);
const AdminReportsPage = React.lazy(() =>
  import('pages/AdminReportsPage/AdminReportsPage')
);
const NewOrderPage = React.lazy(() =>
  import('pages/NewOrderPage/NewOrderPage')
);
const OrdersDetailsPage = React.lazy(() =>
  import('pages/OrdersDetailsPage/OrdersDetailsPage')
);
const JobDetailsPage = React.lazy(() =>
  import('pages/JobDetailsPage/JobDetailsPage')
);
const JobListPage = React.lazy(() => import('pages/JobListPage/JobListPage'));
const JobDetailsQAPage = React.lazy(() =>
  import('pages/JobDetailsQAPage/JobDetailsQAPage')
);
const CustomerListManagerPage = React.lazy(() =>
  import('pages/CustomerListManagerPage/CustomerListManagerPage')
);
const CustomerDetailsManagerPage = React.lazy(() =>
  import('pages/CustomerDetailsManagerPage/CustomerDetailsManagerPage')
);
const NewPartTypesPage = React.lazy(() =>
  import('pages/NewPartTypesPage/NewPartTypesPage')
);
const PartTypesDetailsPage = React.lazy(() =>
  import('pages/PartTypesDetailsPage/PartTypesDetailsPage')
);
const PartTypesManagerPage = React.lazy(() =>
  import('pages/PartTypesManagerPage/PartTypesManagerPage')
);
const POListCustomerPage = React.lazy(() =>
  import('pages/POListCustomerPage/POListCustomerPage')
);
const PartTypesListCustomerPage = React.lazy(() =>
  import('pages/PartTypesListCustomerPage/PartTypesListCustomerPage')
);
const RFQDetailsPage = React.lazy(() =>
  import('pages/RFQDetailsPage/RFQDetailsPage')
);
const NewRFQPage = React.lazy(() => import('pages/NewRFQPage/NewRFQPage'));
const CustomerListShippingPage = React.lazy(() =>
  import('pages/CustomerListShippingPage/CustomerListShippingPage')
);
const CustomerDetailsShippingPage = React.lazy(() =>
  import('pages/CustomerDetailsShippingPage/CustomerDetailsShippingPage')
);
const PartTypesShippingPage = React.lazy(() =>
  import('pages/PartTypesShippingPage/PartTypesShippingPage')
);
const OrderDetailsHistoryPage = React.lazy(() =>
  import('pages/OrderDetailsHistoryPage/OrderDetailsHistoryPage')
);
const ProductionManagerPage = React.lazy(() =>
  import('pages/ProductionManagerPage/ProductionManagerPage')
);
const JobDetailsFinalQAPage = React.lazy(() =>
  import('pages/JobDetailsFinalQAPage/JobDetailsFinalQAPage')
);
const JobDetailsNCRPage = React.lazy(() =>
  import('pages/JobDetailsNCRPage/JobDetailsNCRPage')
);
const ProductionDetailsManagerPage = React.lazy(() =>
  import('pages/ProductionDetailsManagerPage/ProductionDetailsManagerPage')
);
const RFQListCustomerPage = React.lazy(() =>
  import('pages/RFQListCustomerPage/RFQListCustomerPage')
);
const SignUpConfirmPage = React.lazy(() =>
  import('pages/SignUpConfirmPage/SignUpConfirmPage')
);
const ChangeTempPasswordPage = React.lazy(() =>
  import('pages/ChangeTempPasswordPage/ChangeTempPasswordPage')
);
const ForgotPasswordPage = React.lazy(() =>
  import('pages/ForgotPasswordPage/ForgotPasswordPage')
);
const CheckVersionPage = React.lazy(() =>
  import('pages/CheckVersionPage/CheckVersionPage')
);
const CheckQrCodePage = React.lazy(() =>
  import('pages/CheckQrCodePage/CheckQrCodePage')
);
const AdminTravelerTemplateDetailsPage = React.lazy(() =>
  import(
    'pages/AdminTravelerTemplateDetailsPage/AdminTravelerTemplateDetailsPage'
  )
);
const BatchJobDetailsPage = React.lazy(() =>
  import('pages/BatchJobDetailsPage/BatchJobDetailsPage')
);
const AdminTravelerTemplateCreatePage = React.lazy(() =>
  import('pages/AdminTemplateCreatePage/AdminTemplateCreatePage')
);
const EmptyPage = React.lazy(() => import('pages/EmptyPage/EmptyPage'));

function ProtectedRouter() {
  return (
    <Router history={history}>
      <Suspense fallback={<Loader isVisible />}>
        <Switch>
          <CustomRoute
            exact
            path={getValidPath(ROUTES.createTraveler.path)}
            component={ProtectedRoute(NewTravelerPage)}
            roles={ROUTES.createTraveler.roles}
            isProtected
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.treavelersDetails.path)}
            component={ProtectedRoute(TravelersDetailsPage)}
            roles={ROUTES.treavelersDetails.roles}
            isProtected
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.adminCustomers.path)}
            component={ProtectedRoute(AdminCustomersPage)}
            roles={ROUTES.adminCustomers.roles}
            isProtected
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.adminEmployees.path)}
            component={ProtectedRoute(AdminEmployeesPage)}
            roles={ROUTES.adminEmployees.roles}
            isProtected
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.adminTravelerTemplates.path)}
            component={ProtectedRoute(AdminTravelerTemplatesPage)}
            roles={ROUTES.adminTravelerTemplates.roles}
            isProtected
          />

          <CustomRoute
            exact
            path={getValidPath(ROUTES.adminTravelerTemplateCreate.path)}
            component={ProtectedRoute(AdminTravelerTemplateCreatePage)}
            roles={ROUTES.adminTravelerTemplateCreate.roles}
            isProtected
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.adminTravelerTemplateDetails.path)}
            component={ProtectedRoute(AdminTravelerTemplateDetailsPage)}
            roles={ROUTES.adminTravelerTemplateDetails.roles}
            isProtected
          />

          <CustomRoute
            exact
            path={getValidPath(ROUTES.adminNCR.path)}
            component={ProtectedRoute(AdminNCRPage)}
            roles={ROUTES.adminNCR.roles}
            isProtected
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.adminReports.path)}
            component={ProtectedRoute(AdminReportsPage)}
            roles={ROUTES.adminReports.roles}
            isProtected
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.adminControlValues.path)}
            component={ProtectedRoute(AdminControlValuesPage)}
            roles={ROUTES.adminControlValues.roles}
            isProtected
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.customerDetails.path)}
            component={ProtectedRoute(CustomerDetailsPage)}
            roles={ROUTES.customerDetails.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.createOrder.path)}
            component={ProtectedRoute(NewOrderPage)}
            roles={ROUTES.createOrder.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.jobDetails.path)}
            component={ProtectedRoute(JobDetailsPage)}
            roles={ROUTES.jobDetails.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.jobDetailsBatch.path)}
            component={ProtectedRoute(BatchJobDetailsPage)}
            roles={ROUTES.jobDetailsBatch.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.jobDetailsNCR.path)}
            component={ProtectedRoute(JobDetailsNCRPage)}
            roles={ROUTES.jobDetailsNCR.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.ordersDetails.path)}
            component={ProtectedRoute(OrdersDetailsPage)}
            roles={ROUTES.ordersDetails.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.jobList.path)}
            component={ProtectedRoute(JobListPage)}
            roles={ROUTES.jobList.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.jobDetailsQA.path)}
            component={ProtectedRoute(JobDetailsQAPage)}
            roles={ROUTES.jobDetailsQA.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.customerListManager.path)}
            component={ProtectedRoute(CustomerListManagerPage)}
            roles={ROUTES.customerListManager.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.customerDetailsManager.path)}
            component={ProtectedRoute(CustomerDetailsManagerPage)}
            roles={ROUTES.customerDetailsManager.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.createPartTypes.path)}
            component={ProtectedRoute(NewPartTypesPage)}
            roles={ROUTES.createPartTypes.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.partTypesDetails.path)}
            component={ProtectedRoute(PartTypesDetailsPage)}
            roles={ROUTES.partTypesDetails.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.partTypesListManager.path)}
            component={ProtectedRoute(PartTypesManagerPage)}
            roles={ROUTES.partTypesListManager.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.orderListCustomer.path)}
            component={ProtectedRoute(POListCustomerPage)}
            roles={ROUTES.orderListCustomer.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.partTypesListCustomer.path)}
            component={ProtectedRoute(PartTypesListCustomerPage)}
            roles={ROUTES.partTypesListCustomer.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.rfqListCustomer.path)}
            component={ProtectedRoute(RFQListCustomerPage)}
            roles={ROUTES.rfqListCustomer.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.customerListShipping.path)}
            component={ProtectedRoute(CustomerListShippingPage)}
            roles={ROUTES.customerListShipping.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.customerDetailsShipping.path)}
            component={ProtectedRoute(CustomerDetailsShippingPage)}
            roles={ROUTES.customerDetailsShipping.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.partTypesListShipping.path)}
            component={ProtectedRoute(PartTypesShippingPage)}
            roles={ROUTES.partTypesListShipping.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.orderDetailsHistory.path)}
            component={ProtectedRoute(OrderDetailsHistoryPage)}
            roles={ROUTES.orderDetailsHistory.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.productionManager.path)}
            component={ProtectedRoute(ProductionManagerPage)}
            roles={ROUTES.productionManager.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.productionDetailsManager.path)}
            component={ProtectedRoute(ProductionDetailsManagerPage)}
            roles={ROUTES.productionDetailsManager.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.jobDetailsFinalQA.path)}
            component={ProtectedRoute(JobDetailsFinalQAPage)}
            roles={ROUTES.jobDetailsFinalQA.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.emptyPage.path)}
            component={ProtectedRoute(EmptyPage)}
            roles={ROUTES.emptyPage.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.checkVersion.path)}
            component={CheckVersionPage}
            roles={ROUTES.checkVersion.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.signIn.path)}
            component={SignInPage}
            roles={ROUTES.signIn.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.signUpConfirm.path)}
            component={SignUpConfirmPage}
            roles={ROUTES.signUpConfirm.roles}
            isRedirect={false}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.changeTempPassword.path)}
            component={ProtectedRoute(ChangeTempPasswordPage)}
            roles={ROUTES.changeTempPassword.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.loginEmployee.path)}
            component={LoginEmployeePage}
            roles={ROUTES.loginEmployee.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.forgotPassword.path)}
            component={ForgotPasswordPage}
            roles={ROUTES.forgotPassword.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.signOut.path)}
            component={SignOutPage}
            roles={ROUTES.signOut.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.createRfq.path)}
            component={ProtectedRoute(NewRFQPage)}
            roles={ROUTES.createRfq.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.rfqDetails.path)}
            component={ProtectedRoute(RFQDetailsPage)}
            roles={ROUTES.rfqDetails.roles}
          />
          <CustomRoute
            exact
            path={getValidPath(ROUTES.checkQrCode.path)}
            component={CheckQrCodePage}
            roles={ROUTES.checkQrCode.roles}
          />
          <CustomRedirect />
        </Switch>
      </Suspense>
    </Router>
  );
}

export default ProtectedRouter;
